import React, { FC } from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import { AddOn } from 'src/marketing/plans/types'
import { PlanFragment } from 'src/graphql'
import { DecoratedPlan } from 'src/redux/selectors/plans'
import { Text } from '@sendoutcards/quantum-design-ui'

type PlanContextProps = {
  plans: Array<PlanFragment | AddOn | DecoratedPlan>
}

const PlanContext: FC<PlanContextProps> = props => {
  const { children, plans } = props
  return (
    <div style={{ textAlign: 'left' }}>
      {plans.map(plan => {
        const isAddon =
          plan.title.indexOf('Elite') > -1 || plan.title.indexOf('System') > -1
        return (
          <List key={plan.title}>
            <ListItem id={'plan_type'}>
              <ListItemText
                primary={
                  <Text type="caption">{`${plan.title} ${
                    isAddon ? 'Package' : 'Subscription'
                  }`}</Text>
                }
                secondary={
                  <Text type="caption">{`${plan.price.description}/${
                    isAddon && 'billingInterval' in plan
                      ? plan.billingInterval
                      : 'Month'
                  }`}</Text>
                }
                disableTypography={true}
              />
            </ListItem>
          </List>
        )
      })}
      {children}
    </div>
  )
}

export default PlanContext
